module.exports = __webpack_public_path__ + "static/media/rainy.7c5ad644.svg";